import { Routes, Route, Navigate } from 'react-router-dom'
import { AppLayout } from '@/components/layout/AppLayout'
import { Login } from '@/pages/Login'
import { Dashboard } from '@/pages/Dashboard'
import { WhatsappOverview } from '@/pages/whatsapp/Overview'
import { CampanasPage } from '@/pages/whatsapp/campanas'
import { AutoservicioPage } from '@/pages/whatsapp/autoservicio'
import { HumanaPage } from '@/pages/whatsapp/humana'
import { RevisionPage } from '@/pages/whatsapp/revision'
import { Placeholder } from '@/pages/Placeholder'
import { RequireAuth, RedirectIfAuthed } from '@/lib/auth'

function App() {
  return (
    <Routes>
      {/* Pública: si ya hay sesión, redirige a /dashboard */}
      <Route
        path="/login"
        element={
          <RedirectIfAuthed>
            <Login />
          </RedirectIfAuthed>
        }
      />

      {/* App protegida */}
      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />

        <Route path="whatsapp" element={<WhatsappOverview />} />
        <Route path="whatsapp/campanas" element={<CampanasPage />} />
        <Route path="whatsapp/autoservicio" element={<AutoservicioPage />} />
        <Route path="whatsapp/humana" element={<HumanaPage />} />
        <Route path="whatsapp/revision" element={<RevisionPage />} />

        <Route
          path="voz"
          element={<Placeholder title="Agente de voz" description="Camila Andrade — próximamente. Hoy corre en el sistema externo." />}
        />

        <Route
          path="settings"
          element={<Placeholder title="Settings" description="Configuración del tenant, equipo, templates, billing e integraciones." />}
        />

        <Route
          path="*"
          element={<Placeholder title="Página no encontrada" description="La ruta que intentaste visitar no existe." />}
        />
      </Route>
    </Routes>
  )
}

export default App
